import type { BillingModel } from "./BillingModel";
import type {
  Prestation,
  PrestationRequest,
  Product,
  ProductRequest,
  CustomerProduct,
  CounterMovement,
  PurchaseRequest,
  BatchConsumeRequest,
  BatchConsumeResult,
  AdjustRequest,
} from "./Billing.typed";

export class BillingAdapter {
  constructor(private model: BillingModel) {}

  async listGroups(entity: "prestations" | "products"): Promise<string[]> {
    return this.model.listGroups(entity);
  }

  async listPrestations(): Promise<Prestation[]> {
    return this.model.listPrestations();
  }

  async getPrestation(id: number): Promise<Prestation> {
    return this.model.getPrestation(id);
  }

  async createPrestation(payload: PrestationRequest): Promise<Prestation> {
    return this.model.createPrestation(payload);
  }

  async updatePrestation(id: number, payload: PrestationRequest): Promise<Prestation> {
    return this.model.updatePrestation(id, payload);
  }

  async deletePrestation(id: number): Promise<void> {
    return this.model.deletePrestation(id);
  }

  async listProducts(): Promise<Product[]> {
    return this.model.listProducts();
  }

  async getProduct(id: number): Promise<Product> {
    return this.model.getProduct(id);
  }

  async createProduct(payload: ProductRequest): Promise<Product> {
    return this.model.createProduct(payload);
  }

  async updateProduct(id: number, payload: ProductRequest): Promise<Product> {
    return this.model.updateProduct(id, payload);
  }

  async deleteProduct(id: number): Promise<void> {
    return this.model.deleteProduct(id);
  }

  async listCustomerCounters(customerId: number, status?: string): Promise<CustomerProduct[]> {
    return this.model.listCustomerCounters(customerId, status);
  }

  async purchaseProduct(payload: PurchaseRequest): Promise<CustomerProduct> {
    return this.model.purchaseProduct(payload);
  }

  async batchConsume(payload: BatchConsumeRequest): Promise<BatchConsumeResult[]> {
    return this.model.batchConsume(payload);
  }

  async adjustCounter(id: number, payload: AdjustRequest): Promise<CustomerProduct> {
    return this.model.adjustCounter(id, payload);
  }

  async cancelCounter(id: number): Promise<void> {
    return this.model.cancelCounter(id);
  }

  async listCounterMovements(id: number): Promise<CounterMovement[]> {
    return this.model.listCounterMovements(id);
  }
}
